import PropTypes from 'prop-types';
import React, { useState, useContext } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { DXFavoritesContext } from '@contexts/DXFavoritesContext';
import ShareSvg from 'pubweb-smokey/dist/images/svg/iconography-16x16/share-branch.svg';
import FavoritingHeart from '@components/Shared/Favoriting/FavoritingHeart';
import ChevronRightSvg from 'pubweb-smokey/dist/images/svg/iconography-16x16/chevron-right.svg';
import Modal from '@components/Shared/Modal/Modal';
import LoadingIndicator from '@components/Shared/LoadingIndicator/LoadingIndicator';
import InspirationMediaShare from './InspirationMediaShare';
import { InspirationMediaViewStyles } from './InspirationMediaView.styled';
import { formatHttpsUrl } from '@utils/utils';

const InspirationMediaView = ({ media }) => {
  const [showShareModal, setShowShareModal] = useState(false);
  const favoritesContext = useContext(DXFavoritesContext);

  return (
    <InspirationMediaViewStyles>
      {media &&
        (media.category.toLowerCase() === '3d-tours' && media.matterportId ? (
          <iframe
            title="Matterport 3D Tour"
            scrolling="no"
            frameBorder="0"
            allowFullScreen
            allow="xr-spatial-tracking"
            src={`https://my.matterport.com/show/?m=${media.matterportId}`}
          />
        ) : (
          <Link
            href={'/homes/' + media.modelNumber + '/'}
            className="media-image"
          >
            <Image
              alt={media.altText}
              src={media && formatHttpsUrl(`${media.mediaUrl}?w=500&fm=webp`)}
              width={500}
              height={500}
            />
          </Link>
        ))}
      {!media && (
        <div className="media-loading">
          <LoadingIndicator width="50" height="50" />
        </div>
      )}
      <div className="media-details">
        <span className="media-actions">
          <span
            tabIndex="0"
            className="share"
            onClick={() => setShowShareModal(true)}
          >
            <ShareSvg />
          </span>
          <span tabIndex="0" className="favorite">
            {media && (
              <FavoritingHeart
                isFavorited={
                  !!favoritesContext.state.favoriteModels?.filter(
                    (faveModels) => faveModels.modelNumber === media.modelNumber
                  )[0]
                }
                onClick={() =>
                  favoritesContext.actions.toggleFavoriteModel(
                    media.modelNumber
                  )
                }
              />
            )}
          </span>
        </span>
        {media && (
          <span className="media-header">
            <Link
              href={'/homes/' + media.modelNumber + '/'}
              className="standard"
            >
              <h3>{media.modelName}</h3>
              <div className="chevron">
                <ChevronRightSvg viewBox="0 0 16 16" />
              </div>
            </Link>
            <p>{media.description}</p>
          </span>
        )}
      </div>
      {showShareModal && (
        <Modal
          onClose={(e) => {
            setShowShareModal(false);
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <InspirationMediaShare media={media} />
        </Modal>
      )}
    </InspirationMediaViewStyles>
  );
};

InspirationMediaView.propTypes = {
  media: PropTypes.shape({
    altText: PropTypes.any,
    category: PropTypes.string,
    description: PropTypes.any,
    matterportId: PropTypes.any,
    mediaUrl: PropTypes.any,
    modelId: PropTypes.any,
    modelName: PropTypes.any,
    modelNumber: PropTypes.any,
  }),
};

export default InspirationMediaView;
